import platform from 'platform'

import debug from 'debug'

const log = debug('app:initializers/debug')

export default function () {
  log('ENV', process.env.NODE_ENV)
  log('Platform (including Browser Info)', platform)
  log('OS', platform.os)
}
